import React from 'react';
import '../styles/DefaultUserImage.css';
import { HugeiconsIcon } from '@hugeicons/react';
import { CameraSmile02Icon } from '@hugeicons/core-free-icons';
import { colour } from '../styles/GlobalStyles';

const DefaultUserImage = React.memo(function DefaultUserImage(props) {
    const clickFunc = props.clickFunc;
    const size = props.size;
    const image = props.image;
    return (
        <div
            className={"default-user-image-container " + (size === "small" ? "default-user-image-small " : "default-user-image-large ") + (clickFunc === null ? "" : "cursor-pointer")}
            onClick={() => clickFunc === null ? null : clickFunc()}
            style={image ? { backgroundImage: `url(${image})` } : {}}
        >
            {
                image === null &&
                <HugeiconsIcon
                    icon={CameraSmile02Icon}
                    color={colour.gray03}
                    size={size === "small" ? 20 : 24}
                />
            }
        </div>
    )
});

export default DefaultUserImage;